// extracted by mini-css-extract-plugin
export default {"buttons":"buttons__XSJsC4"};